import type { ReactNode } from 'react';
import s from './PortalShell.module.css';

export function PortalShell({ children }: { children: ReactNode }) {
  return (
    <div className={s.shell}>
      <div className={s.body}>{children}</div>
    </div>
  );
}
